



































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["accountBook"]),
})
export default class VoucherPrint extends Vue {
    @Prop({ type: Object })
    voucher!: Voucher.Voucher;

    @Prop({ type: Number })
    margin!: number;

    @Prop({ type: Number })
    index!: number;

    @Prop({ type: Number })
    padding!: number;

    @Prop({ type: [Number, String], default: 32 })
    lineHeight!: number;

    @Prop({ type: [Number, String], default: 11 })
    fontSize!: number;

    @Prop()
    bookKeeper!: string | null;
    @Prop()
    teller!: string | null;
    @Prop()
    documentMaker!: string | null;

    get rowHeight() {
        return (this.lineHeight / 2.54) * 72;
    }

    startY = 0;
    endY = 0;
    startX = 0;
    endX = 0;
    startDrag(e: any) {
        this.startY = e.y;
    }

    startDragLeft(e: any) {
        this.startX = e.x;
    }

    paddingLr = this.$store.state.voucherPrint.left;
    get cmHeight(): string {
        return ((this.$store.state.voucherPrint.top / 72) * 2.54).toFixed(2);
    }
    get cmLeft(): string {
        return ((this.$store.state.voucherPrint.left / 72) * 2.54).toFixed(2);
    }
    get cmRight(): string {
        return ((this.$store.state.voucherPrint.right / 72) * 2.54).toFixed(2);
    }
    @Watch("cmHeight")
    marginChanged(val: string) {
        this.showTop = val;
    }
    @Watch("cmLeft")
    leftChanged(val: string) {
        this.showLeft = val;
    }
    @Watch("cmRight")
    rightChanged(val: string) {
        this.showRight = val;
    }
    showTop = localStorage.getItem("voucherPrint") ? ((JSON.parse(<string>localStorage.getItem("voucherPrint")).top / 72) * 2.54).toFixed(2) : ((45 / 72) * 2.54).toFixed(2);
    showLeft = localStorage.getItem("voucherPrint") ? ((JSON.parse(<string>localStorage.getItem("voucherPrint")).left / 72) * 2.54).toFixed(2) : ((30 / 72) * 2.54).toFixed(2);
    showRight = localStorage.getItem("voucherPrint") ? ((JSON.parse(<string>localStorage.getItem("voucherPrint")).right / 72) * 2.54).toFixed(2) : ((30 / 72) * 2.54).toFixed(2);
    mounted() {
        this.showTop = ((this.$store.state.voucherPrint.top / 72) * 2.54).toFixed(2);
        this.showLeft = ((this.$store.state.voucherPrint.left / 72) * 2.54).toFixed(2);
        this.showRight = ((this.$store.state.voucherPrint.right / 72) * 2.54).toFixed(2);
    }
    voucherPrint = {
        top: this.$store.state.voucherPrint.top,
        left: this.$store.state.voucherPrint.left,
        right: this.$store.state.voucherPrint.right,
    };
    saveChange() {
        Vue.axios
            .post(`accounts/printer/set/save`, {
                voucherPrint: JSON.stringify(this.voucherPrint),
                accounterId: this.$store.state.account.id,
            });
    }
    changeTop() {
        let top = +this.showTop;
        if (+this.showTop < 0) {
            this.showTop = "0";
            top = (+0 / 2.54) * 72;
            this.voucherPrint.top = top;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        } else {
            top = (+top / 2.54) * 72;
            if (top > 100) {
                top = 100;
                this.showTop = (
                    (+this.$store.state.voucherPrint.top / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.top = top;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        }
    }
    changeLeft() {
        let Left = +this.showLeft;
        if (+this.showLeft < 0) {
            this.showLeft = "0";
            Left = 0;
            this.voucherPrint.left = Left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
            this.$forceUpdate();
        } else {
            Left = (+Left / 2.54) * 72;
            if (Left > 100) {
                Left = 100;
                this.showLeft = (
                    (+this.$store.state.voucherPrint.left / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.left = Left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
            this.$forceUpdate();
        }
    }
    changeRight() {
        let Right = +this.showRight;
        if (+this.showRight < 0) {
            this.showRight = "0";
            Right = 0;
            this.voucherPrint.right = Right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        } else {
            Right = (+Right / 2.54) * 72;
            if (Right > 100) {
                Right = 100;
                this.showRight = (
                    (+this.$store.state.voucherPrint.right / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.right = Right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        }
    }
    endDrag(e: any) {
        this.endY = e.y;
        let top = this.$store.state.voucherPrint.top;
        let distance = this.endY - this.startY;
        if (distance > 100) {
            top = 100;
        } else {
            top += distance;
        }

        if (top < 0) {
            top = 0;
        }
        this.voucherPrint.top = top;
        this.$store.dispatch("voucherPrintchange", this.voucherPrint);
        localStorage.setItem("voucherPrint", JSON.stringify(this.voucherPrint));
        this.showTop = (
            (this.$store.state.voucherPrint.top / 72) *
            2.54
        ).toFixed(2);
        this.saveChange();
    }

    endDragLeft(e: any, num: number) {
        let left = this.$store.state.voucherPrint.left;
        let right = this.$store.state.voucherPrint.right;
        this.endX = e.x;
        let distance = this.endX - this.startX;
        if (num === 0) {
            if (distance > 100) {
                left = 100;
            } else {
                left += distance;
            }
            if (left < 0) {
                left = 0;
            }
            this.voucherPrint.left = left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.showLeft = (
                (this.$store.state.voucherPrint.left / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        } else {
            if (distance < -100) {
                right = 100;
            } else {
                right -= distance;
            }
            if (right > 100) {
                right = 100;
            }
            if (right < 0) {
                right = 0;
            }
            this.voucherPrint.right = right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.showRight = (
                (this.$store.state.voucherPrint.right / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        }
    }
    // 获取焦点
    selectInner(e: any) {
        this.$nextTick(() => {
            e.target.select();
        });
    }
    @Prop({ type: Number })
    percent!: number;

    @Prop({ type: Boolean })
    horizontal!: boolean;

    // 记账人和出纳可输入
    bookKeeperCopy = this.bookKeeper;
    tellerCopy = this.teller;
    documentMakerCopy = this.documentMaker;
    @Watch("bookKeeper")
    bookKeeperChange(val: string) {
        this.bookKeeperCopy = val;
    }

    @Watch("teller")
    tellerChange(val: string) {
        this.tellerCopy = val;
    }

    @Watch("documentMaker")
    documentMakerChange(val: string) {
        this.documentMakerCopy = val;
    }

    get vRows() {
        return this.$store.state.voucherRows;
    }

    changeSet(attr: string, value: string) {
        this.$emit(`update:${attr}`, value);
        Vue.axios.post(`accounts/printer/set/save`, {
            [attr]: value,
            accounterId: this.$store.state.account.id,
        });
    }
}
